/* eslint-disable complexity */

import YuriMenuSections from '@/components/yuri-menu-sections';

export default {
    name: 'yuri-menu',
    components: {
        YuriMenuSections
    },
    /**
     * @override
     */
    data() {
        return {
            activeSection: undefined,
            active: ''
        };
    },
    methods: {
        /**
         * Cambiamos de pestaña del yuri-menu y comprobamos que no sea la misma en la que está
         * @param {Object} item Item al que cambiar la navegación
         */
        setActive(item) {
            this.$store.dispatch('yuriMenuStore/disableItemsMenu').then(() => {
                this.$store.dispatch('yuriMenuStore/setActiveItem', item).then(() => {
                    this.$store.dispatch('yuriMenuStore/disableItemsSubMenu').then(() => {
                        // this.$store.dispatch('yuriMenuStore/clearAllActiveChildren');
                        if (this.$route.name !== item.route.name || this.$route.params !== item.route.params) {
                            this.$router.replace(item.route);
                        }
                    });
                });
            });
        },
        /**
         * Eliminamos un elemento del array de items del menú.
         * @param {Number} index Índice que queremos borrar el array
         */
        closeItem(index) {
            // 1. Limpiamos los formularios de la pestaña que vayamos a cerrar
            // 2. Si el item a cerrar === activo
            //      cerrar y redirigir al último
            //    Sino
            //      cerrar
            const item = this.$store.getters['yuriMenuStore/items'][index];
            this.$store.dispatch('formStore/deleteRouteForms', item.route.name);

            // Limpiar orderby de localStorage al cerrar la pestaña
            const orderbyKeys = {
                accounts: 'ob_acco',
                interveners: 'ob_int',
                operations: 'ob_oper',
                issues: 'ob_issu',
                users: 'ob_usr',
                permission_set: 'ob_perm',
                groups: 'ob_grp'
            };
            const orderbyKey = orderbyKeys[item.route.name];
            if (orderbyKey) {
                localStorage.removeItem(orderbyKey);
            }
            const itemActive = this.$store.getters['yuriMenuStore/activeItem'];
            if (itemActive !== index) {
                this.$store.dispatch('yuriMenuStore/removeItem', index);
            } else {
                this.$store.dispatch('yuriMenuStore/removeItem', index).then(() => {
                    const lastItem = this.$store.getters['yuriMenuStore/lastItem'];
                    if (lastItem) {
                        this.$store.dispatch('yuriMenuStore/setActiveItem', lastItem).then(() => {
                            this.$router.replace(lastItem.route);
                        });
                    } else {
                        this.$router.push('/dashboard');
                    }
                });
            }
        },
        /**
         * Eliminamos todos los elementos del array de items del menú.
         */
        closeAll() {
            // Limpiar todos los orderby de localStorage
            ['ob_acco', 'ob_int', 'ob_oper', 'ob_issu', 'ob_usr', 'ob_perm', 'ob_grp'].forEach(key => {
                localStorage.removeItem(key);
            });

            this.$store.dispatch('yuriMenuStore/setItems', []);
            if (this.$route.name !== 'dashboard') {
                this.$router.push('/dashboard');
            }
        },
        /**
         * Set icon
         * @param {Object} el Element
         * @return {String} fa icon
         */
        icon(el) {
            // TO-DO: Limpiar esto!
            let icon = '';
            switch (el.route.name) {
                case 'distributors_uuid':
                case 'distributors_add':
                case 'distributors':
                    icon = 'fa-handshake';
                    break;
                case 'groups_uuid':
                case 'groups_add':
                case 'groups':
                    icon = 'fa-users';
                    break;
                case 'users_uuid':
                case 'users_add':
                case 'users':
                    icon = 'fa-user';
                    break;
                case 'permission_sets_uuid':
                case 'permission_set_add':
                case 'permission_set':
                    icon = 'fa-key';
                    break;
                case 'interveners_uuid':
                case 'interveners_add':
                case 'interveners':
                    icon = 'fa-address-card';
                    break;
                case 'accounts_uuid':
                case 'accounts_add':
                case 'accounts':
                    icon = 'fa-credit-card';
                    break;
                case 'issues_add':
                case 'issues_uuid':
                case 'issues':
                    icon = 'fa-exclamation-square';
                    break;
                case 'operations_uuid':
                case 'operations_add':
                case 'operations':
                    icon = 'fa-database';
                    break;
                case 'mismatch-monitor':
                    icon = 'fa-list';
                    break;
                case 'import':
                    icon = 'fa-upload';
                    break;
                case 'conciliation':
                    icon = 'fa-handshake';
                    break;
                case 'conciliation2':
                    icon = 'fa-balance-scale';
                    break;
                default:
                    icon = 'fa-list';
            }
            return icon;
        }
    },
    computed: {
        /**
         * Devuelve el listado de items del menú yuri-menu (primer nivel)
         * @return {Array} Array de items del menú
         */
        items() {
            const items = this.$store.getters['yuriMenuStore/items'];
            return items;
        },
        /**
         * Devuelve el úlitmo item del menú principal que estaba consultando el usuario
         * @return {String} Nombre sección
         */
        lastItem() {
            return this.$store.getters['yuriMenuStore/lastItem'];
        },
        /**
         * @override
         */
        section() {
            return this.$store.getters['yuriMenuStore/section'];
        }
    }
};
